import React from "react";
import { EsgScorecardIcon } from "assets";

export const SCORECARD_PAGE = {
    ABSOLUTE_PATH: "/scorecard",
    TITLE: "Scorecard",
    ICON: <EsgScorecardIcon />,
    renderMenu: false,
    configParameter: "site_based_feature",
    premiumFeatureTooltipInfoMessage: "Upgrade to unlock Scorecard for Custom KPI tracking.",
};

export const SCORECARD_ALLOWED_PERIODS = ["Monthly", "Quarterly", "Yearly"]

export const SELECTED_SITE_LOCAL_STORAGE_KEY = "selectedSite";

/**
 * Column ids pinned left on scorecard tables (main + archived).
 * Actions exists only for admins — non-admin layout has no actions column, so omit it from the pin list.
 */
export const SCORECARD_PINNED_LEFT_COLUMN_IDS_WITH_ACTIONS = [
    "actions",
    "labels",
    "categoryName",
    "kpiName",
] as const;

export const SCORECARD_PINNED_LEFT_COLUMN_IDS_WITHOUT_ACTIONS = [
    "labels",
    "categoryName",
    "kpiName",
] as const;

export function getScorecardPinnedLeftColumnIds(isAdmin: boolean): string[] {
    return isAdmin
        ? [...SCORECARD_PINNED_LEFT_COLUMN_IDS_WITH_ACTIONS]
        : [...SCORECARD_PINNED_LEFT_COLUMN_IDS_WITHOUT_ACTIONS];
}
